const MAP = {
  scheduled: ["Scheduled", "bg-violet-50 text-violet-700 border-violet-200"],
  requested: ["Finding driver", "bg-amber-50 text-amber-700 border-amber-200"],
  accepted: ["Driver on the way", "bg-blue-50 text-blue-700 border-blue-200"],
  arrived: ["Driver arrived", "bg-indigo-50 text-indigo-700 border-indigo-200"],
  in_progress: ["On trip", "bg-sky-50 text-sky-700 border-sky-200"],
  completed: ["Completed", "bg-emerald-50 text-emerald-700 border-emerald-200"],
  cancelled: ["Cancelled", "bg-slate-100 text-slate-500 border-slate-200"],
  expired: ["No driver found", "bg-orange-50 text-orange-700 border-orange-200"],
  pending: ["Pending approval", "bg-amber-50 text-amber-700 border-amber-200"],
  approved: ["Approved", "bg-emerald-50 text-emerald-700 border-emerald-200"],
  rejected: ["Rejected", "bg-red-50 text-red-700 border-red-200"],
  suspended: ["Suspended", "bg-red-50 text-red-700 border-red-200"],
  active: ["Active", "bg-emerald-50 text-emerald-700 border-emerald-200"],
  maintenance: ["Maintenance", "bg-amber-50 text-amber-700 border-amber-200"],
  settled: ["Paid", "bg-emerald-50 text-emerald-700 border-emerald-200"],
  returned: ["Returned to base", "bg-emerald-50 text-emerald-700 border-emerald-200"],
  at_base: ["At base", "bg-emerald-50 text-emerald-700 border-emerald-200"],
  away: ["Not back at base", "bg-red-50 text-red-700 border-red-200"],
  no_gps: ["No GPS data", "bg-slate-100 text-slate-500 border-slate-200"],
  unsettled: ["Owing", "bg-red-50 text-red-700 border-red-200"],
};

export const StatusBadge = ({ status, testId }) => {
  const [label, cls] = MAP[status] || [status, "bg-slate-100 text-slate-600 border-slate-200"];
  return (
    <span data-testid={testId} className={`inline-flex items-center whitespace-nowrap rounded-full border px-2.5 py-0.5 text-xs font-semibold ${cls}`}>
      {label}
    </span>
  );
};
